import React from 'react';
import background from '../../assets/hypoxia_bg.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoHypoxia extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        description="Hypoxia"
        paragraph="Hypoxic zones are areas in the ocean of such low oxygen concentration that animal life suffocates. Fertilizer runoff promotes algal overgrowth, which consumes available oxygen."
        coverbackground={background}
     />
  
  );
 }
}   

export default InfoHypoxia;